<template>
  <div class="popup-card-background">
    <component :is="$store.state.popupQuiz.component"></component>
  </div>
</template>

<script>
import found from '@/components/PopupQuiz/Found'
import notFound from '@/components/PopupQuiz/NotFound'
import Info from '@/components/PopupQuiz/Info'

export default {
  components: {
    found,
    notFound,
    Info
  }
}
</script>

<style lang="scss" scoped>
.popup-card {
  &-background {
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.6);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
